/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancel_KeepInputs */



/**
* | output |
* | --- |
* | "Keep playing" |
*
* @param {Rounds_Cancel_KeepInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancel_keep = /** @type {((inputs?: Rounds_Cancel_KeepInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancel_KeepInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer à jouer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar jugando")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Continuar jogando")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua a giocare")
	return /** @type {LocalizedString} */ ("Keep playing")
});